import AxiosClient from './axios';

export default AxiosClient;
